export default __webpack_public_path__ + "static/media/undraw_messenger_re_8bky.3add7d0c.svg";